// Permisos RBAC de Originación. El endpoint exige `loan.origination.read` en scope TENANT, así que
// la pantalla se esconde hasta que el rol lo tenga sembrado (fail-closed).

/**
 * Clave de permiso de la pantalla. Va como `string` y no como `Permission` porque `PermissionKey`
 * (generado del OpenAPI) hoy no expone ninguna clave de dominio.
 */
export const ORIGINATION_PERMISSIONS = {
    viewAnalytics: 'loan.origination.read',
} as const;

export type OriginationPermissionKey =
    (typeof ORIGINATION_PERMISSIONS)[keyof typeof ORIGINATION_PERMISSIONS];

/** El gate está encendido. Sin la clave sembrada la pantalla queda oculta: es lo correcto. */
export const ORIGINATION_PERMISSIONS_ENFORCED = true;

export interface OriginationAbilities {
    canViewAnalytics: boolean;
}

/** Con `enforce: false` todo queda permitido; con `true` la lectura exige su clave. */
export function resolveOriginationAbilities(
    grantedPermissions: ReadonlySet<string>,
    enforce: boolean = ORIGINATION_PERMISSIONS_ENFORCED,
): OriginationAbilities {
    if (!enforce) return { canViewAnalytics: true };
    return { canViewAnalytics: grantedPermissions.has(ORIGINATION_PERMISSIONS.viewAnalytics) };
}
